import React, { useEffect, useMemo, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import { PageProps } from '../types';

interface InternalAuditModuleLayoutProps {
  children: React.ReactNode;
  pages: PageProps[];
}

const InternalAuditModuleLayout: React.FC<InternalAuditModuleLayoutProps> = ({ children, pages }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const [activePageTitle, setActivePageTitle] = useState('Internal Audit Module');
  const location = useLocation();

  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const activePage = pages.find(page =>
      segments.length > 0 &&
      page.path.replace('/*', '').split('/').filter(Boolean)[0] === segments[0]
    );

    if (activePage) {
      setActivePageTitle(activePage.title);
    }
  }, [location.pathname, pages]);

  const pagePropsList = useMemo<PageProps[]>(() => {
    const mapped = pages.map((page) => ({
      title: page.title,
      icon: page.icon || null,
      tabs: page.tabs,
      path: page.path,
      show: page.show,
      element: page.element
    }));
    const internalAuditPage = mapped.find(p => p.title === 'Internal Audit Module');
    if (internalAuditPage) {
      console.log('Internal Audit Module page in layout:', {
        title: internalAuditPage.title,
        show: internalAuditPage.show,
        path: internalAuditPage.path
      });
    }
    return mapped;
  }, [pages]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const handlePageChange = (title: string) => {
    setActivePageTitle(title);
  };

  return (
    <div className="internal-audit-module">
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          overflow: 'hidden',
          bgcolor: '#F9FAFB'
        }}
      >
        <Sidebar
          isOpen={isSidebarOpen}
          onToggle={toggleSidebar}
          activePageTitle={activePageTitle}
          onPageChange={handlePageChange}
          pagePropsList={pagePropsList}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: isSidebarOpen ? '310px' : '64px',
            height: '100vh',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            '@media (max-width: 600px)': {
              marginLeft: isSidebarOpen ? '0' : '64px',
              width: '100%',
            },
          }}
        >
          {children}
        </Box>
      </Box>
    </div>
  );
};

export default InternalAuditModuleLayout;


